'use client';

import { useEffect, useState } from 'react';

// Drives the fixed nav: solid background past 80px and a scroll-progress bar.
export default function useNavScrollState() {
  const [isSolid, setIsSolid] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let frame = 0;

    const onScroll = () => {
      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        const scrollY = window.pageYOffset;
        const scrollable =
          document.documentElement.scrollHeight - window.innerHeight;

        setIsSolid(scrollY > 80);
        setProgress(
          scrollable > 0 ? Math.min(100, (scrollY / scrollable) * 100) : 0
        );
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return { isSolid, progress };
}
